module.exports = __webpack_public_path__ + "static/media/stop-9.6602b28a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stop-markers/stop-9.svg
// module id = 1354
// module chunks = 0